<template>
  <form @submit.prevent="onSubmit">
    <div class="container">
      <div class="columns">
        <div class="column is-half is-offset-one-quarter">

          <div class="field">
            <label class="label">Email</label>
            <p class="control">
              <input v-model="email" class="input" type="email" placeholder="Email">
            </p>
          </div>

          <div class="field">
            <label class="label">Password</label>
            <p class="control">
              <input v-model="password" class="input" type="password" placeholder="Password">
            </p>
          </div>

          <div class="field">
            <p class="control">
              <button class="button is-primary">Submit</button>
            </p>
          </div>

        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    onSubmit() {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.push('/admin');
        })
        .catch(() => this.resetForm());
    },
    resetForm() {
      this.email = '';
      this.password = '';
    },
  },
};
</script>

<style scoped>

  form {
    margin-top: 40px;
  }

  .label {
    color: #FFF;
  }

</style>



// WEBPACK FOOTER //
// Login.vue?184d78de